import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Pagination } from 'components/pagination/Pagination';
import { SubTitle } from 'components/text/SubTitle';
import { Typography, closeModal, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { SubTitleStyle } from 'modules/dashboard/styles/card-item';
import { Grid_3 } from 'modules/dashboard/styles/lesson';

import { isEmpty, orderBy } from 'lodash';

import { TABLE_KEY } from 'constants/table';

import { CardItem } from '../components/CardItem';
import { Header } from '../components/Header';
import { useLessonsController } from '../core/controller/lessons';
import { useLibrary } from '../core/hook';

export const LessonsPage = () => {
  const {
    lessonsData,
    queryState,
    total,
    selectedLessons,
    setSelectedLessons,
    onChangeSelectedLessons,
    searchLesson,
    searchValue,
    onChangeSearchLesson,
    onChangeSearchValue,
    handleAddToCourse,
    handleEditLesson,
    handleDeleteLesson,
    goToLessonDetail,
    onDeleteLesson,
    handleDelete,
    coursesData,
    handleDuplicateLesson,
  } = useLessonsController();

  const { onClickAddItem } = useLibrary();

  const selectedLessonsTotal = Object.keys(selectedLessons).length;

  const showCheckbox = !isEmpty(Object.keys(selectedLessons));

  const renderListLesson = () => {
    return (
      <>
        <Grid_3>
          {lessonsData.map((el, index) => {
            const selected = Boolean(selectedLessons[el.id]);

            const orderByExercise = orderBy(el.exercises, 'index');

            return (
              <CardItem
                key={index}
                selected={selected}
                onChange={onChangeSelectedLessons(el.id)}
                goToDetailPage={() => goToLessonDetail(el.id)}
                handleEdit={() => handleEditLesson(el.id)}
                handleDelete={() => handleDeleteLesson(el.id)}
                handleDuplicate={() => handleDuplicateLesson(el.id)}
                hideAction={false}
                name={el.name}
                id={el.id}
                thumbnail={el.thumbnail as string}
                subTitle={
                  <SubTitle
                    leftTitle={<SubTitleStyle>{el.type.name}</SubTitleStyle>}
                    rightTitle={<SubTitleStyle>{`${el.totalExercises} exercises`}</SubTitleStyle>}
                  />
                }
                showCheckbox={showCheckbox}
              />
            );
          })}
        </Grid_3>
        <Pagination total={total.value} queryState={queryState} tableKey={TABLE_KEY.LESSONS} />
      </>
    );
  };

  return (
    <div>
      <Header
        selected={selectedLessons}
        title="Add to course"
        placeholderSearch="Search by course"
        options={coursesData}
        setSelected={setSelectedLessons}
        onDelete={() => openModal(MODAL_KEY.DELETE_LESSON)}
        searchValueBySelected={searchValue.value}
        onAdd={handleAddToCourse}
        type="lesson"
        searchValue={searchLesson.value}
        onChangeSearch={onChangeSearchLesson}
        onChangeSearchBySelected={onChangeSearchValue}
        onClickAddItem={onClickAddItem}
      />
      {lessonsData.length > 0 ? (
        renderListLesson()
      ) : (
        <Typography
          variant="h3"
          weight={700}
          style={{ textAlign: 'center', justifyContent: 'center', marginTop: 30 }}
        >
          No data
        </Typography>
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_LESSON}
        content={'Deleting will also remove them from all existing courses.'}
        header={`Delete ${selectedLessonsTotal === 0 ? '' : selectedLessonsTotal} lessons`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_LESSON)}
        onSubmit={() => {
          isEmpty(selectedLessons) ? onDeleteLesson() : handleDelete();
          closeModal(MODAL_KEY.DELETE_LESSON);
        }}
      />
    </div>
  );
};
